define.alias("shared/utils/crop-array", "media/utils/crop-array");